import React, { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Modal } from "@mui/material";
import strings from "../../../../locales/ro.json";
import PopUpResponseButton from "../../../../components/Buttons/PopUpResponseButton/PopUpResponseButton";
import "./WhatsAppStatus.css";

const s = strings.admin.contacting.whatsapp;

const STATUS_CONFIG = {
  disconnected: { label: s.statusDisconnected, shortLabel: s.statusDisconnectedShort, className: "wa-status-disconnected" },
  initializing: { label: s.statusInitializing, shortLabel: s.statusInitializingShort, className: "wa-status-initializing" },
  qr: { label: s.statusQr, shortLabel: s.statusQrShort, className: "wa-status-qr" },
  ready: { label: s.statusReady, shortLabel: s.statusReadyShort, className: "wa-status-ready" },
  auth_failure: { label: s.statusAuthFailure, shortLabel: s.statusAuthFailureShort, className: "wa-status-error" },
};

const WhatsAppStatusIndicator = ({ status, onClick }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.disconnected;

  return (
    <div className={`wa-status-indicator ${config.className}`} onClick={onClick}>
      <span className="wa-status-dot" />
      <span className="wa-status-label wa-desktop-text">{config.label}</span>
      <span className="wa-status-label wa-mobile-text">{config.shortLabel}</span>
    </div>
  );
};

const WhatsAppQRModal = ({ isOpen, onClose, qrCode, status, onConnect, onDisconnect }) => {
  const isReady = status === "ready";

  useEffect(() => {
    if (isOpen && (status === "disconnected" || status === "auth_failure")) {
      onConnect();
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="wa-modal-overlay" onClick={onClose}>
        <div className="wa-modal-container" onClick={(e) => e.stopPropagation()}>
          <div className="wa-modal-header">
            <h2 className="wa-modal-title">{s.modalTitle}</h2>
          </div>

          <div className="wa-modal-content">
            {isReady ? (
              <div className="wa-connected-msg">
                <span className="wa-connected-icon">✓</span>
                <p>{s.connectedMessage}</p>
              </div>
            ) : qrCode ? (
              <div className="wa-qr-section">
                <p className="wa-qr-instructions">{s.scanInstructions}</p>
                <div className="wa-qr-wrapper">
                  <QRCodeSVG value={qrCode} size={256} level="M" />
                </div>
                <p className="wa-qr-hint">{s.scanHint}</p>
              </div>
            ) : (
              <div className="wa-loading-section">
                <div className="wa-spinner" />
                <p>{s.waitingForQr}</p>
              </div>
            )}
          </div>

          <div className="wa-modal-footer">
            <PopUpResponseButton
              type="cancel"
              text="Închide"
              onClick={onClose}
            />
            {isReady && onDisconnect && (
              <PopUpResponseButton
                type="cancel"
                text="Deconectează"
                onClick={onDisconnect}
              />
            )}
            <WhatsAppStatusIndicator status={status} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export { WhatsAppStatusIndicator, WhatsAppQRModal };
